/**
 * Shared web-push constants.
 */

/**
 * Re-registration cadence — keeps tokens fresh and catches rotation.
 * Matches AIM's 7-day cadence.
 */
export const REREGISTER_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * SW → page relay message type for silent `token_refresh` pushes. The
 * service worker is the delivery point for web push whether the tab is
 * focused or not; pages listen for this and re-register. Keep in sync with
 * each app's `public/firebase-messaging-sw.js`.
 */
export const SW_MESSAGE_TOKEN_REFRESH = 'TOKEN_REFRESH';
